import * as React from 'react';
import * as cn from 'classnames';
import { LoaderIcon } from '@cian/ui-kit/prev/icons';

import { Text } from '../../Text';
import { ISelectedPublication } from '../types';
import { IGetArticleResponse } from '../../../repositories/valuation-b2b/v1/get-article';
import * as styles from './styles.css';

interface IPublicationContentProps {
  articleId: number;

  selectPublication(articleId: number): ISelectedPublication;
}

export const PublicationContent: React.FC<IPublicationContentProps> = ({ articleId, selectPublication }) => {
  const publication = selectPublication(articleId);

  if (publication.isFetching || publication.isError) {
    return (
      <div className={styles['container']}>
        <div className={styles['preloader']}>
          <LoaderIcon custom={{ size: '28' }} styles={{ color: 'C9C9C9' }} />
        </div>
      </div>
    );
  }

  const { text, title, source } = publication.article as IGetArticleResponse;

  return (
    <div className={cn(styles['container'])}>
      {source.logoUrl && <img className={styles['img']} src={source.logoUrl} alt={source.displayName} />}
      <div className={styles['modal-title']}>
        <Text size="h3" bold>
          {title}
        </Text>
      </div>
      <div className={styles['modal-content']}>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </div>
  );
};

PublicationContent.displayName = 'PublicationContent';
